// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"186":"04eb9950af627e27","315":"0b427de5290e7f8f","338":"39d4765655921f3d","357":"e1a153eb25c6041e","421":"6a5c3cacfc6da051","518":"505d5224214982db","657":"89a08aa06a0207c2","711":"d6c9803e8c531d55","889":"46184d003af1f24d"}[chunkId] + ".js";
};